import { useId } from "react";

/**
 * A file field that looks like the rest of the dialog: a "Choose file" button and the chosen
 * file's name, over a real file input that keeps its label, keyboard focus and screen reader name.
 */
export default function FilePicker({
  id,
  accept = ".pdf,image/*",
  file,
  onChange,
  disabled = false,
  invalid = false,
}: {
  id?: string;
  accept?: string;
  file: File | null;
  onChange: (file: File | null) => void;
  disabled?: boolean;
  invalid?: boolean;
}) {
  const generated = useId();
  const inputId = id ?? generated;
  return (
    <div
      className={`flex items-center gap-3 rounded-lg border bg-white px-3 py-2 text-sm focus-within:ring-1 focus-within:ring-[#1B4ED7] ${
        invalid ? "border-[#B00020]" : "border-gray-300"
      } ${disabled ? "bg-gray-50" : ""}`}
    >
      <label
        htmlFor={inputId}
        className={`shrink-0 rounded-md border border-[#165FE3] px-3 py-1.5 font-medium text-[#165FE3] ${
          disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:bg-[#F0F4FF]"
        }`}
      >
        {file ? "Change file" : "Choose file"}
      </label>
      <span className={`min-w-0 flex-1 truncate ${file ? "text-[#333333]" : "text-[#555555]"}`}>
        {file ? file.name : "No file chosen"}
      </span>
      <input
        id={inputId}
        type="file"
        accept={accept}
        disabled={disabled}
        className="sr-only"
        onChange={(e) => onChange(e.target.files?.[0] ?? null)}
      />
    </div>
  );
}
